var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("InvoiceDisputesDialog.title"),
        visible: _vm.visible,
        "before-close": _vm.handleClose
      }
    },
    [
      _c("invoice-disputes-table", {
        attrs: {
          "legal-entity": _vm.legalEntity,
          recipient: _vm.recipient,
          invoices: _vm.invoices
        },
        on: { change: _vm.handleInvoiceDisputesTableChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }